"use client";

import type {} from "@mui/lab/themeAugmentation";
import { baseTheme } from "@osn/react-components";

export default baseTheme;
